document.addEventListener('DOMContentLoaded', function () {
  const middleSections = document.querySelector('.middle-sections');
  const headerWrap = document.querySelector('.header-wrap');

  if (!middleSections || !headerWrap) return;

  const placeholder = document.createElement('div');
  placeholder.classList.add('header-placeholder');
  middleSections.parentNode.insertBefore(placeholder, middleSections.nextSibling);

  function updatePlaceholderHeight() {
    placeholder.style.height = middleSections.offsetHeight + 'px';
  }

  let isSticky = false;

  function onScroll() {
    const scrollY = window.scrollY;
    const halfHeightTrigger =
      middleSections.offsetTop + middleSections.offsetHeight / 2;

    if (window.innerWidth < 1280) {
      middleSections.classList.remove('is-sticky', 'header-transform');
      headerWrap.classList.remove('is-sticky');
      placeholder.style.height = '0px';
      isSticky = false;
      return;
    }

    if (scrollY >= halfHeightTrigger) {
      if (!isSticky) {
        updatePlaceholderHeight();
        middleSections.classList.add('is-sticky', 'header-transform');
        headerWrap.classList.add('is-sticky');
        isSticky = true;
      }
    } else {
      middleSections.classList.remove('is-sticky', 'header-transform');
      headerWrap.classList.remove('is-sticky');
      placeholder.style.height = '0px';
      isSticky = false;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    if (isSticky) updatePlaceholderHeight();
    onScroll();
  });

  onScroll();
});